import { createRouter, createWebHistory } from 'vue-router'

// Lazy load components
const LandingPage = () => import('../components/LandingPage.vue')
const Home = () => import('../components/Home.vue')
const NeighborhoodFeed = () => import('../components/NeighborhoodFeed.vue')
const NeighborhoodsPage = () => import('../components/NeighborhoodsPage.vue')
const Profile = () => import('../components/Profile.vue')
const UserFeed = () => import('../components/UserFeed.vue')
const PostView = () => import('../components/PostView.vue')
const StaticPage = () => import('../components/StaticPage.vue')
const StatesPage = () => import('../components/StatesPage.vue')
const StatePage = () => import('../components/StatePage.vue')
const RegionsPage = () => import('../components/RegionsPage.vue')
const RegionDetailPage = () => import('../components/RegionDetailPage.vue')
const CityNeighborhoodsPage = () => import('../components/CityNeighborhoodsPage.vue')
const ZipcodePage = () => import('../components/ZipcodePage.vue')
const PlacesPage = () => import('../components/PlacesPage.vue')

const routes = [
  {
    path: '/',
    name: 'landing',
    component: LandingPage
  },
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/neighborhoods',
    name: 'neighborhoods',
    component: NeighborhoodsPage
  },
  {
    path: '/places',
    name: 'places',
    component: PlacesPage
  },
  {
    path: '/zipcode/:zipcode',
    name: 'zipcode',
    component: ZipcodePage,
    props: true
  },
  {
    path: '/states',
    name: 'states',
    component: StatesPage
  },
  {
    path: '/state/:stateName',
    name: 'state',
    component: StatePage,
    props: true
  },
  {
    path: '/regions',
    name: 'regions',
    component: RegionsPage
  },
  {
    path: '/region/:regionSlug',
    name: 'region-detail',
    component: RegionDetailPage,
    props: true
  },
  {
    path: '/neighborhood/:state/:city/:slug',
    name: 'neighborhood',
    component: NeighborhoodFeed,
    props: true
  },
  {
    path: '/neighborhood/:state/:city',
    name: 'city',
    component: CityNeighborhoodsPage,
    props: true
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile
  },
  {
    path: '/user/:userId',
    name: 'user-posts',
    component: UserFeed,
    props: true
  },
  {
    path: '/post/:postId',
    name: 'post-view',
    component: PostView,
    props: true
  },
  // Static footer pages
  {
    path: '/about',
    name: 'about',
    component: StaticPage,
    props: { page: 'about' }
  },
  {
    path: '/contact',
    name: 'contact',
    component: StaticPage,
    props: { page: 'contact' }
  },
  {
    path: '/terms',
    name: 'terms',
    component: StaticPage,
    props: { page: 'terms' }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: StaticPage,
    props: { page: 'privacy' }
  },
  {
    path: '/dmca',
    name: 'dmca',
    component: StaticPage,
    props: { page: 'dmca' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router